import script from "./ServiceRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceRow.vue?vue&type=script&setup=true&lang=js"

import "./ServiceRow.vue?vue&type=style&index=0&id=581e53ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581e53ae"]])

export default __exports__